import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import Icon from 'components/Icon';
import WatchList, { FAVORITE_TYPE_WATCHLIST } from 'components/Favorite';
import { noop } from 'helpers/GlobalHelper';
import Style from './ActionButtons.module.scss';

const ActionButtons = ({
  favoriteData = null,
  favorites = null,
  favoritesManager = null,
  handleSetFavorite = () => {},
  hasSeries = false,
  hoverStateWatchlistText = '',
  iconType = '',
  isOnlyInfo = false,
  isOnlyWatchList = false,
  link = '',
  moreInfoAria = '',
  moreInfoText = '',
  onMoreInfoClick = () => {},
  render = true,
  segmentPlaylistButtonAction = () => {},
}) => {
  const hoverStateToolTip = (label, toolTipClassName, isRightJustified) => (
    <div
      className={classNames([
        Style.hoverStateToolTip,
        toolTipClassName,
        isRightJustified && Style.hoverStateToolTipRight,
      ])}
    >
      <div className={Style.hoverStateToolTipLabel}>{label}</div>
      <div className={Style.hoverStateToolTipTip} />
    </div>
  );
  return (
    render && (
      <div className={Style.hoverStateActionButtons}>
        {hasSeries && (
          <div
            className={classNames([
              Style.infoButton,
              isOnlyInfo ? Style.rightActionButton : Style.leftActionButton,
            ])}
          >
            <Link
              onClick={onMoreInfoClick}
              onMouseDown={e => (e.button === 1 ? onMoreInfoClick() : noop)}
              to={link}
              className={classNames(Style.infoButtonLink)}
            >
              <Icon
                ariaLabel={moreInfoAria}
                color="white"
                icon="info-thin"
                role="link"
                size="full"
                viewBox="0 0 26 26"
              />
            </Link>
            {hoverStateToolTip(moreInfoText, Style.infoToolTip, isOnlyInfo)}
          </div>
        )}
        {!isOnlyInfo && (
          <div className={classNames([Style.watchListButton, Style.rightActionButton])}>
            <span className={Style.watchListButtonContainer}>
              <WatchList
                type={FAVORITE_TYPE_WATCHLIST}
                stopNavigationOnClick
                manager={favoritesManager}
                iconType={iconType}
                favorites={favorites}
                data={favoriteData}
                segmentPlaylistButtonAction={segmentPlaylistButtonAction}
                setFavorite={handleSetFavorite}
              />
            </span>
            {hoverStateToolTip(hoverStateWatchlistText, Style.watchListToolTip, isOnlyWatchList)}
          </div>
        )}
      </div>
    )
  );
};

ActionButtons.propTypes = {
  favoriteData: PropTypes.shape({}),
  favorites: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({}),
  handleSetFavorite: PropTypes.func,
  hasSeries: PropTypes.bool,
  hoverStateWatchlistText: PropTypes.string,
  iconType: PropTypes.string,
  isOnlyInfo: PropTypes.bool,
  isOnlyWatchList: PropTypes.bool,
  link: PropTypes.string,
  moreInfoAria: PropTypes.string,
  moreInfoText: PropTypes.string,
  onMoreInfoClick: PropTypes.func,
  render: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
};

export default ActionButtons;
